module.exports = __webpack_public_path__ + "static/media/imperial-brands-logo.1dad6c0d.png";